module.exports = __webpack_public_path__ + "img/weddings_33_V.39026a51.webp";